var AttributedString, ElementType, _, bmlTags, buildFragmentFromNodeRanges, calculateInitialNodeRanges, compareNodeRanges, dom, seekTagRangeEnd;

AttributedString = require('./attributed-string');

bmlTags = require('./attributed-string-bml-tags');

ElementType = require('domelementtype');

_ = require('underscore-plus');

dom = require('./dom');

AttributedString.prototype.toInlineBMLString = function() {
  var p;
  p = dom.createElement('p');
  this.toInlineBMLInContainer(p);
  return dom.getInnerHTML(p, {
    decodeEntities: true,
    lowerCaseTags: true,
    xmlMode: true
  });
};

AttributedString.prototype.toInlineBMLInContainer = function(container) {
  var nodeRangeStack, nodeRanges;
  nodeRanges = calculateInitialNodeRanges(this);
  nodeRangeStack = [
    {
      start: 0,
      end: this.getLength(),
      node: container
    }
  ];
  return buildFragmentFromNodeRanges(nodeRanges, nodeRangeStack);
};

calculateInitialNodeRanges = function(attributedString) {
  var attrName, attrValue, attributeName, attributeValue, element, k, len, nodeRange, nodeRanges, ref, ref1, run, runBuffer, runLocation, string, tagsToRanges, text;
  nodeRanges = [];
  if (attributedString.runBuffer) {
    tagsToRanges = {};
    runLocation = 0;
    runBuffer = 0;
    ref = attributedString.getRuns();
    for (k = 0, len = ref.length; k < len; k++) {
      run = ref[k];
      ref1 = run.attributes;
      for (attributeName in ref1) {
        attributeValue = ref1[attributeName];
        nodeRange = tagsToRanges[attributeName];
        if (!nodeRange || nodeRange.end <= runLocation) {
          if (bmlTags[attributeName]) {
            element = dom.createElement(attributeName);
            if (typeof attributeValue === 'string') {
              element.attribs['value'] = attributeValue;
            } else if (_.isObject(attributeValue)) {
              for (attrName in attributeValue) {
                attrValue = attributeValue[attrName];
                element.attribs[attrName] = attrValue.toString();
              }
            }
          } else {
            element = dom.createElement('span');
            element.attribs[attributeName] = attributeValue.toString();
          }
          nodeRange = {
            node: element,
            start: runLocation,
            end: seekTagRangeEnd(attributeName, attributeValue, runBuffer, runLocation, attributedString)
          };
          tagsToRanges[attributeName] = nodeRange;
          nodeRanges.push(nodeRange);
        }
      }
      text = run.getString();
      if (text !== AttributedString.ObjectReplacementCharacter && text !== AttributedString.LineSeparatorCharacter) {
        nodeRanges.push({
          start: runLocation,
          end: runLocation + run.getLength(),
          node: dom.createTextNode(text)
        });
      }
      runLocation += run.getLength();
      runBuffer++;
    }
    nodeRanges.sort(compareNodeRanges);
  } else {
    string = attributedString.getString();
    nodeRanges = [
      {
        start: 0,
        end: string.length,
        node: dom.createTextNode(string)
      }
    ];
  }
  return nodeRanges;
};

seekTagRangeEnd = function(tagName, seekTagAttributes, runBuffer, runLocation, attributedString) {
  var attributeRuns, end, equalAttributes, run, runTagAttributes;
  attributeRuns = attributedString.getRuns();
  end = attributeRuns.length;
  while (true) {
    run = attributeRuns[runBuffer++];
    runTagAttributes = run.attributes[tagName];
    equalAttributes = runTagAttributes === seekTagAttributes || _.isEqual(runTagAttributes, seekTagAttributes);
    if (!equalAttributes) {
      return runLocation;
    } else if (runBuffer === end) {
      return runLocation + run.getLength();
    }
    runLocation += run.getLength();
  }
};

compareNodeRanges = function(a, b) {
  var aNodeType, aTagName, bNodeType, bTagName;
  if (a.start < b.start) {
    return -1;
  } else if (a.start > b.start) {
    return 1;
  } else if (a.end !== b.end) {
    return b.end - a.end;
  } else {
    aNodeType = a.node.type;
    bNodeType = b.node.type;
    if (aNodeType !== bNodeType) {
      if (aNodeType === ElementType.Text) {
        return 1;
      } else if (bNodeType === ElementType.Text) {
        return -1;
      } else {
        aTagName = a.node.name;
        bTagName = b.node.name;
        if (aTagName < bTagName) {
          return -1;
        } else if (aTagName > bTagName) {
          return 1;
        } else {
          return 0;
        }
      }
    } else {
      return 0;
    }
  }
};

buildFragmentFromNodeRanges = function(nodeRanges, nodeRangeStack) {
  var i, j, parentRange, range, splitEnd, splitStart;
  i = 0;
  while (i < nodeRanges.length) {
    range = nodeRanges[i++];
    parentRange = nodeRangeStack.pop();
    while (nodeRangeStack.length && parentRange.end <= range.start) {
      parentRange = nodeRangeStack.pop();
    }
    if (range.end > parentRange.end) {
      splitStart = range;
      splitEnd = {
        end: splitStart.end,
        start: parentRange.end,
        node: dom.cloneNode(splitStart.node)
      };
      splitStart.end = parentRange.end;
      j = nodeRanges.indexOf(parentRange);
      while (compareNodeRanges(nodeRanges[j], splitEnd) < 0) {
        j++;
      }
      nodeRanges.splice(j, 0, splitEnd);
    }
    dom.appendChild(parentRange.node, range.node);
    nodeRangeStack.push(parentRange);
    nodeRangeStack.push(range);
  }
  return nodeRangeStack[0].node;
};

module.exports = AttributedString;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/attributed-string-to-bml.js
 ** module id = 72
 ** module chunks = 0
 **/